import { runOnJS } from 'react-native-reanimated';
import { useKeyboardHandler } from 'react-native-keyboard-controller';
import { useState } from 'react';
export function useKeyboard() {
    const [keyboardHeight, setKeyboardHeight] = useState(0);
    useKeyboardHandler({
        onStart: (e) => {
            'worklet';
            if (e.progress === 1) {
                runOnJS(setKeyboardHeight)(e.height);
            }
            else {
                runOnJS(setKeyboardHeight)(0);
            }
        },
    }, []);
    return {
        keyboardHeight,
    };
}
